export const lambdaURL = "https://4nmomp1cfd.execute-api.us-west-2.amazonaws.com/default/vmBase/post-resource";
